import { useRef, useState } from 'react';
import { useDidUpdateEffect } from './useDidUpdateEffect';
export var usePrevious = function usePrevious(value, useInitialValue) {
  if (useInitialValue === void 0) {
    useInitialValue = false;
  }

  var _useState = useState(useInitialValue ? value : undefined),
      previous = _useState[0],
      setPrevious = _useState[1];

  var ref = useRef(value);
  useDidUpdateEffect(function () {
    if (ref.current !== value) {
      setPrevious(ref.current);
      ref.current = value;
    }
  }, [value]);
  return previous;
};